import { ColorsRaw } from '@/ui/theme/colors-raw';

export const ColorsScore = {
  A: {
    text: ColorsRaw.anthracite.Anthracite_1,
    main: ColorsRaw.scores.Green,
    secondary: ColorsRaw.scores.Green_012,
  },
  B: {
    text: ColorsRaw.anthracite.Anthracite_1,
    main: ColorsRaw.scores.Lime,
    secondary: ColorsRaw.scores.Lime_012,
  },
  C: {
    text: ColorsRaw.anthracite.Anthracite_1,
    main: ColorsRaw.scores.Mandarine,
    secondary: ColorsRaw.scores.Mandarine_012,
  },
  D: {
    text: ColorsRaw.anthracite.Anthracite_1,
    main: ColorsRaw.scores.Orange,
    secondary: ColorsRaw.scores.Orange_012,
  },
  E: {
    text: ColorsRaw.basic.White,
    main: ColorsRaw.scores.Pink,
    secondary: ColorsRaw.scores.Pink_012,
  },
  none: {
    text: ColorsRaw.basic.White,
    main: ColorsRaw.scores.Anthracite_4,
    secondary: ColorsRaw.scores.Antracite_4012,
  },
};
